const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  ADMINISTRATION: '/administration',
  SETTINGS: '/settings',
  DISTRIBUTION: '/distribution',
  RECOMMENDATIONS: '/recommendations',
  INFO_MESSAGES: '/info-messages',
};

export default ROUTES;